export { default } from './FaqEntitats';
